import { useComposerStore } from '../hooks/useComposerStore'

/**
 * Whether per-channel content should be served from the Zustand
 * `channelVariants` collection right now.
 *
 * The mirror seeds `channelVariants` in an effect (post-render), so the first
 * render still falls back to legacy reads until `channelBridgeReady` flips
 * true — the same readiness discipline the omni bridge applies via
 * `omniBridgeReady`.
 */
export function useChannelVariantReadsActive(): boolean {
  return useComposerStore((state) => state.channelBridgeReady)
}
